import { render, staticRenderFns } from "./WorshipItem.vue?vue&type=template&id=6e5d17f1&scoped=true&"
import script from "./js/worship-item.js?vue&type=script&lang=js&"
export * from "./js/worship-item.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5d17f1",
  null
  
)

export default component.exports